import { Component, OnInit, Inject, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BZG_MODAL_DATA, BzgModalRef} from 'bz-genome-angular';
import { Store } from '@ngrx/store';
import { IAppState } from 'app/IAppState';
import { IQueueItem } from 'app/rpa-bots/uipath/common/models/IQueueItem';


@Component({
  selector: 'bz-detail-confirm-queueitems-modal',
  templateUrl: './detail-confirm-queueitems-modal.component.html',
  styleUrls: ['./detail-confirm-queueitems-modal.component.scss']
})
export class DetailConfirmQueueitemsModalComponent implements OnInit {

  @Input() queueitem: IQueueItem;
  @Input() specificData: any;

  constructor(private _modalRef: BzgModalRef,
    @Inject(BZG_MODAL_DATA) public initialData: IQueueItem, private _store: Store<IAppState>) {


      if (initialData.SpecificData) {
        this.specificData = JSON.parse(initialData.SpecificData);
      }
      else {
        this.specificData = null;
      }

  }

  public form = new FormGroup({
    queueDefinitionId: new FormControl(''),
    specificData: new FormControl(''),
    idQueueitem: new FormControl(''),
  });

  ngOnInit() {
    if (this.initialData) {
      this.form = new FormGroup({
        queueDefinitionId: new FormControl(this.initialData.QueueDefinitionId.toString()),
        specificData: new FormControl(this.initialData.SpecificData),
        idQueueitem: new FormControl(this.initialData.Id.toString()),
      });
    }
  }

  async retryQueueitem(queueitem: IQueueItem) {
    this._modalRef.close(queueitem);
  }

}
